import axios from "axios";

export interface Pickles {
  id?: string;
  companyId: string;
  companyLocationId: string;
  name: string;
  isDeleted?: boolean;
}

export async function addPickles(pickles: Pickles) {
  return axios.post<Pickles>("/Pickeleses/addpickeleses", pickles);
}

export async function getallPicklesByCompanyId(companyId: string) {
  return axios
    .get<Pickles[]>(`/Pickeleses/getallpickelesesbycompanyid`, {
      params: { CompanyId: companyId },
    })
    .then((res) => res.data.filter((pickles) => !pickles.isDeleted));
}

export async function updatePickles(pickles: Pickles) {
  return axios.put<Pickles>(`/Pickeleses/updatepickeleses`, pickles);
}

export async function deletePickles(id: string) {
  return axios.delete(`/Pickeleses/deletepickeleses`, { data: { id } });
}
